import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { NgbActiveModal, NgbDate } from '@ng-bootstrap/ng-bootstrap';
import { format } from 'date-fns';
import { DateUtilService } from 'gung-common';
import { CheckoutObject } from 'gung-standard';

@Component({
  selector: 'app-hl-display-customer-service-edit-transport-details-modal',
  templateUrl: './hl-display-customer-service-edit-transport-details-modal.component.html',
  styleUrl: './hl-display-customer-service-edit-transport-details-modal.component.css',
  standalone: false
})
export class HlDisplayCustomerServiceEditTransportDetailsModalComponent implements OnInit {
  public checkout: CheckoutObject;

  public isLoading: boolean = true;
  public form: FormGroup;
  public today: Date = new Date();

  constructor(
    protected activeModal: NgbActiveModal,
    public dateUtilService: DateUtilService
  ) { }

  ngOnInit(): void {
    this.initForm();
  }

  protected initForm(): void {
    this.form = new FormGroup({
      q_hl_logentcontactperson: new FormControl({ value: this.checkout?.extra?.oh?.q_hl_logentcontactperson, disabled: false }, []),
      q_hl_logentcontactdetails: new FormControl({ value: this.checkout?.extra?.oh?.q_hl_logentcontactdetails, disabled: false }, []),
      q_hl_logentdeliveryinstruction: new FormControl({ value: this.checkout?.extra?.oh?.q_hl_logentdeliveryinstruction, disabled: false }, []),
      q_hl_deliverytimeearliest: new FormControl({ value: this.checkout?.extra?.oh?.q_hl_deliverytimeearliest, disabled: false }, []),
      q_hl_deliverytimelatest: new FormControl({ value: this.checkout?.extra?.oh?.q_hl_deliverytimelatest, disabled: false }, []),
    });

    this.isLoading = false;
  }

  public dateSelected(date: Date, formControlName: string): void {
    this.form.get(formControlName).setValue(format(date, this.dateUtilService.dateFormat));
  }

  public onSave(): void {
    const formRawValue = this.form.getRawValue();
    this.activeModal.close(formRawValue);
  }

  public close(): void {
    this.activeModal.dismiss();
  }
}
